import * as THREE from 'three';
import {CSS2DRenderer, CSS2DObject} from 'three/examples/jsm/renderers/CSS2DRenderer.js'
import EnvironementGenerator from './EnvironementGenerator.js';
import UIConnector from './UIConnector.js';

export default class UIGenerator {
	constructor(scene, uiToSetup, envGenerator, data) {
		this.scene = scene;
		this.uiToSetup = uiToSetup;
		this.envGenerator = envGenerator;
		this.uiConnector = new UIConnector(envGenerator, this);

		if (data) {
			this.data = data;
		}

		if (document.getElementsByClassName("base-ui").length > 0) {
			this.baseEl = document.getElementsByClassName("base-ui")[0];
		}
		else {
			this.baseEl = document.createElement('div');
		}
		this.el = document.createElement('div');
		
		this.br = document.createElement("br");
		this.text = document.createElement("p");
	}

	SetupUI(isAdmin, defaultRoom) {
		this.BaseUI();
		
		var selectElementValue = {};
		var functionToSend;
		switch(this.uiToSetup) {
			case "Room_1_3":
				if (!defaultRoom) 
					defaultRoom = "1";
				var collapsibleContent = this.Collapsible("Configuration de salle");
				this.uiConnector.SetZone("Room_1_3", defaultRoom);

				selectElementValue.viewName = ["Salle 1", "Salle 2", "Salle 3", "Salle 1 + 2", "Salle 2 + 3", "Salle 1 + 2 + 3"];
				selectElementValue.backName = ["1", "2", "3", "1_2", "2_3", "1_2_3"];
				functionToSend = function(e){
					this.uiConnector.ChangeRoom(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, this.data.d.s);
				}
				else {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, defaultRoom);
				}

				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Table ronde", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Ronde", "Cocktail", "Vide"];
				functionToSend = function(e){
					this.uiConnector.ChangeConfigType(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent, this.data.c);
				}
				else {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent);
				}

				var configUI = document.createElement('div');

				collapsibleContent.appendChild(configUI);
				this.uiConnector.SetConfigDiv(configUI);

				if (this.data) {
					this.uiConnector.ChangeConfigType(this.data.c, this.data);
				}
				else {
					this.uiConnector.ChangeConfigType("Theatre");
				}
				break;
			case "Room_4_7":
				if (!defaultRoom) 
					defaultRoom = "4";
				var collapsibleContent = this.Collapsible("Configuration de salle");
				this.uiConnector.SetZone("Room_4_7", defaultRoom);

				selectElementValue.viewName = ["Salle 4", "Salle 4 + 5", "Salle 4 + 5 + 6", "Salle 4 + 5 + 6 + 7"];
				selectElementValue.backName = ["4", "5", "6", "7"];
				functionToSend = function(e){
					this.uiConnector.ChangeRoom(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, this.data.d.s);
				}
				else {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, defaultRoom);
				}

				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Cocktail", "Vide"];
				functionToSend = function(e){
					this.uiConnector.ChangeConfigType(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent, this.data.c);
				}
				else {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent);
				}

				var configUI = document.createElement('div');

				collapsibleContent.appendChild(configUI);
				this.uiConnector.SetConfigDiv(configUI);

				if (this.data) {
					this.uiConnector.ChangeConfigType(this.data.c, this.data);
				}
				else {
					this.uiConnector.ChangeConfigType("Theatre");
				}
				break;
			case "Room_8_11":
				if (!defaultRoom) 
					defaultRoom = "11";
				var collapsibleContent = this.Collapsible("Configuration de salle");
				this.uiConnector.SetZone("Room_8_11", defaultRoom);

				selectElementValue.viewName = ["Salle 11", "Salle 10 + 11", "Salle 9 + 10 + 11", "Salle 8 + 9 + 10 + 11"];
				selectElementValue.backName = ["11", "10", "9", "8"];
				functionToSend = function(e){
					this.uiConnector.ChangeRoom(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, this.data.d.s);
				}
				else {
					this.AddSelectElement(selectElementValue, "Choix de salle", "room-choice", functionToSend, collapsibleContent, defaultRoom);
				}

				selectElementValue.viewName = ["Théâtre", "U", "Classe", "Pôle de travail", "Cocktail", "Vide"];
				selectElementValue.backName = ["Theatre", "U", "Classe", "Travail", "Cocktail", "Vide"];
				functionToSend = function(e){
					this.uiConnector.ChangeConfigType(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent, this.data.c);
				}
				else {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent);
				}

				var configUI = document.createElement('div');

				collapsibleContent.appendChild(configUI);
				this.uiConnector.SetConfigDiv(configUI);

				if (this.data) {
					this.uiConnector.ChangeConfigType(this.data.c, this.data);
				}
				else {
					this.uiConnector.ChangeConfigType("Theatre");
				}
				break;
			case "Lully":
				var collapsibleContent = this.Collapsible("Configuration de salle");
				this.uiConnector.SetZone("Lully", "Lully");

				selectElementValue.viewName = ["Théâtre", "Table ronde", "Cocktail", "Diner", "Soirée dansante", "Vide"];
				selectElementValue.backName = ["Theatre", "Ronde", "Cocktail", "Diner", "Danse", "Vide"];
				functionToSend = function(e){
					this.uiConnector.ChangeConfigType(e.target.value);
				}.bind(this);
				if (this.data) {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent, this.data.c);
				}
				else {
					this.AddSelectElement(selectElementValue, "Type de configuration", "config-type", functionToSend, collapsibleContent);
				}

				var configUI = document.createElement('div');

				collapsibleContent.appendChild(configUI);
				this.uiConnector.SetConfigDiv(configUI);

				if (this.data) {
					this.uiConnector.ChangeConfigType(this.data.c, this.data);
				}
				else {
					this.uiConnector.ChangeConfigType("Theatre");
				}

				break;
			case "Foyer" :
				var collapsibleContent = this.Collapsible("Configuration de salle");
				this.uiConnector.SetZone("Foyer", "Foyer");
				var configUI = document.createElement('div');

				collapsibleContent.appendChild(configUI);
				this.uiConnector.SetConfigDiv(configUI);
				this.uiConnector.ChangeConfigType("Foyer");
				break;
		}

		if (isAdmin) {
			this.SimsUI();
		}

		this.br = document.createElement("br");
		this.el.appendChild(this.br);

		this.AddCheckboxElement("Vue première personne", "cam-type", false,);

		this.br = document.createElement("br");
		this.el.appendChild(this.br);

		var button = document.createElement("button");
		button.innerText = "Générer un lien de partage";
		button.classList.add("red-button");
		this.el.appendChild(button);

		button.addEventListener ("click", function() {
			this.uiConnector.ExportLink();
		}.bind(this));

		this.br = document.createElement("br");
		this.el.appendChild(this.br);

		var tInput = document.createElement("input");
		tInput.type = "text";
		tInput.id = "link";
		tInput.readOnly = true;
		this.el.appendChild(tInput);

		tInput.addEventListener ("click", function() {
			this.select();
		});

		var spaceDiv = document.createElement('div');
		spaceDiv.style.height = "10%";
		this.el.appendChild(spaceDiv);

	}

	ClearUI() {
		this.el.innerHTML = "";
		this.baseEl.innerHTML = "";
	}

	ChangeObject(uiToSetup, envGenerator) {
		this.uiToSetup = uiToSetup;
		this.envGenerator = envGenerator;
	}

	
	/// PRIVATE

	BaseUI() {
		this.el.classList.add("inner-ui");
		this.baseEl.classList.add("base-ui");
		this.baseEl.classList.add("base-ui-hide");
		this.baseEl.classList.remove("base-ui-show");
		const objectCSS = new CSS2DObject(this.baseEl);

		var button = document.createElement("button");
		button.innerText = "Menu";
		button.classList.add("base-button-hide");
		this.baseEl.appendChild(button);

		this.baseEl.appendChild(this.el);
		this.el.style.display = "none";

		button.addEventListener ("click", function() {
			this.classList.toggle("active");
			var content = this.nextElementSibling;
			if (content.style.display === "block") {
				content.style.display = "none";
				this.parentNode.classList.remove("base-ui-show");
				this.parentNode.classList.add("base-ui-hide");
				this.classList.remove("base-button-show");
				this.classList.add("base-button-hide");
			} else {
				content.style.display = "block";
				//this.parentNode.style.backgroundColor = "#3F4F59";
				this.parentNode.classList.remove("base-ui-hide");
				this.parentNode.classList.add("base-ui-show");
				this.classList.remove("base-button-hide");
				this.classList.add("base-button-show");
			}
		});

		objectCSS.name = "ui";
		this.scene.add(objectCSS);
	}

	SimsUI() {
		var selectElementValue = {};
		var functionToSend;
		var classToAdd = ["button-1-2"];
		this.br = document.createElement("br");

		var collapsibleContent = this.Collapsible("Configuration avancée");

		var categorieMove = this.Collapsible("Déplacement", collapsibleContent);
		var categorieRotate = this.Collapsible("Rotation", collapsibleContent);
		var categorieSelect = this.Collapsible("Selection", collapsibleContent);
		var categorieBibliotheque = this.Collapsible("Bibliotheque", collapsibleContent, true);
		var categorieElements = this.Collapsible("Tous les éléments", collapsibleContent);

		this.AddTextElement("Déplacer sur l'axe", "moveAxe", categorieMove);

		functionToSend = function(e){
			var element = document.getElementById("moveDistance");
			var data = {x: parseFloat(element.value), y: 0, z: 0};
			this.uiConnector.SimsControllerFunction("MoveObject", data);
		}.bind(this);
		this.AddButton("X", categorieMove, functionToSend, classToAdd);

		functionToSend = function(e){
			var element = document.getElementById("moveDistance");
			var data = {x: 0, y: 0, z: parseFloat(element.value)};
			this.uiConnector.SimsControllerFunction("MoveObject", data);
		}.bind(this);
		this.AddButton("Z", categorieMove, functionToSend, classToAdd);

		this.AddValueInputElement("Distance", "moveDistance", {default: 0}, null, categorieMove);
		
		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("ResetPosObject");
		}.bind(this);
		this.AddButton("Reset position", categorieMove, functionToSend);

		functionToSend = function(e){
			var data = {x: 0, y: Math.PI/2, z: 0};
			this.uiConnector.SimsControllerFunction("RotateObject", data);
		}.bind(this);
		this.AddButton("Rotation 90°", categorieRotate, functionToSend);

		functionToSend = function(e){
			if (e.target.value < 0) {
				e.target.value = 0;
			}
			else if (e.target.value > 360) {
				e.target.value = 360;
			}

			var data = {x: 0, y: e.target.value, z: 0};
			this.uiConnector.SimsControllerFunction("RotateObjectFromDegree", data);
		}.bind(this);
		this.AddValueInputElement("Tourner objet", "rotationSelection", {default: 0, max:360, min:0, step: 10}, functionToSend, categorieRotate);


		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("ResetRotObject");
		}.bind(this);
		this.AddButton("Reset rotation", categorieRotate, functionToSend);

		functionToSend = function(e){
			var data = {range: true};
			this.uiConnector.SimsControllerFunction("SelectRange", data);
		}.bind(this);
		this.AddButton("Rangée", categorieSelect, functionToSend);

		functionToSend = function(e){
			var data = {range: false};
			this.uiConnector.SimsControllerFunction("SelectRange", data);
		}.bind(this);
		this.AddButton("Colonne", categorieSelect, functionToSend);

		var bibliothequeData = [["bibliotheque/Table_Ronde", "Table ronde"],
		["Ronde", "Table ronde avec chaises"],
		["bibliotheque/Table_Reunion", "Table de réunion"],
		["Classe", "Table de réunion avec chaises"],
		["Pole", "Pole de travail"],
		["bibliotheque/Table_Buffet", "Table de buffet"],
		["bibliotheque/Table_Buffet_Petit", "Petite table de buffet"],
		["bibliotheque/Mange_Debout", "Mange debout"],
		["bibliotheque/Gueridon", "Gueridon"],
		["bibliotheque/Chaise_Bleue", "Chaise bleue"],
		["bibliotheque/Fauteuil_Orange", "Fauteuil orange"],
		["bibliotheque/Fauteuil_Grand_Gris", "Grand fauteuil gris"],
		["bibliotheque/Canape", "Canape"],
		["bibliotheque/Praticable", "Praticable"],
		["bibliotheque/Grand_Ecran", "Grand écran"],
		["bibliotheque/Pot", "Pot de plantes"],
		["bibliotheque/Enceintes", "Enceintes"],
		["bibliotheque/Potelets", "Potelets"],
		["bibliotheque/RetourEcran", "Retour ecran"],
		["bibliotheque/Pupitre", "Pupitre"],
		["bibliotheque/Paper_Board", "Paper board"],
		["bibliotheque/Portant", "Portant"],
		["bibliotheque/Chaise_Haute", "Chaise haute"],
		["bibliotheque/Table_Basse_Bois", "Table basse"],
		["bibliotheque/Table_Basse_Marbre", "Table basse"],
		["bibliotheque/Stand_2_2", "Stand 2x2"],
		["bibliotheque/Stand_2_3", "Stand 2x3"],
		["bibliotheque/Stand_3_3", "Stand 3x3"],
		["bibliotheque/Stand_4_4", "Stand 4x4"],
		["bibliotheque/Prise", "Prise électrique"],
		["bibliotheque/Sortie_Secours", "Sortie de secours"]];

		for(var i = 0; i < bibliothequeData.length; i++) {
			this.AddElementToBibliotheque(bibliothequeData[i], categorieBibliotheque);
		}

		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("RefreshObjectInScene");
		}.bind(this);
		this.AddButton("Actualiser", categorieElements, functionToSend);
		this.AddTextElement("Tous les éléments :", "all-element", categorieElements);

		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("ResetObject");
		}.bind(this);
		this.AddButton("Reset l'objet", collapsibleContent, functionToSend);

		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("DupliqueSelection");
		}.bind(this);
		this.AddButton("Dupliquer sélection", collapsibleContent, functionToSend);

		functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("HideObject");
		}.bind(this);
		this.AddButton("Cacher la sélection", collapsibleContent, functionToSend);
	}

	AddElementToBibliotheque(data, whereToAdd) {
		var functionToSend = function(e){
			this.uiConnector.SimsControllerFunction("AddElementFromBibliotheque", data[0]);
		}.bind(this);
		this.AddBibliothequeButton(data[0], data[1], whereToAdd, functionToSend, ["button-bibliotheque"]);
	}

	AddSelectElement(possibleConfigType, innerText, id, functionToAdd, container, defaultValue) {
		var whereToAddContent = container || this.el;
		
		this.text = document.createElement("p");
		this.br = document.createElement("br");

		this.text.innerText = innerText;
		whereToAddContent.appendChild(this.text);

		var selectElement = document.createElement("select");
		selectElement.id = id;

		for (var i = 0; i < possibleConfigType.viewName.length; i++) {
			selectElement.options[i] = new Option(possibleConfigType.viewName[i], possibleConfigType.backName[i]);
			if (defaultValue == possibleConfigType.backName[i]) {
				selectElement.options[i].selected = true;
			}
		}
		selectElement.onchange = functionToAdd;

		whereToAddContent.appendChild(selectElement);
		whereToAddContent.appendChild(this.br);
	}

	ChangeSelectElement(id, newValue, defaultValue) {
		var selector = document.getElementById(id);
		while (selector.options.length > 0) {                
			selector.remove(0);
		}

		for (var i = 0; i < newValue.viewName.length; i++) {
			selector.options[i] = new Option(newValue.viewName[i], newValue.backName[i]);
			if (newValue.backName[i] == defaultValue) {
				selector.options[i].selected = true;
			}
		}
	}

	AddTextElement(innerText, id, container) {
		var whereToAddContent = container || this.el;
		this.text = document.createElement("p");

		this.text.innerText = innerText;
		this.text.id = id;
		whereToAddContent.appendChild(this.text);
	}


	ChangeTextElement(id, value) {
		var selector = document.getElementById(id);
		selector.innerText = value;
	}

	AddRangeInputElement(innerText, id, defaultValue, functionToAdd, container) {
		var whereToAddContent = container || this.el;

		this.text = document.createElement("p");
		this.br = document.createElement("br");

		this.text.innerText = innerText;
		this.text.id = id + "-text";
		whereToAddContent.appendChild(this.text);

		var inputElement = document.createElement("input");
		inputElement.id = id;
		inputElement.type = "range";
		if (defaultValue.default) {
			inputElement.value = defaultValue.default;
		}
		if (defaultValue.max)
			inputElement.max = defaultValue.max;
		if (defaultValue.min)
			inputElement.min = defaultValue.min;
		if (defaultValue.step)
			inputElement.step = defaultValue.step;

		inputElement.onchange = functionToAdd;

		whereToAddContent.appendChild(inputElement);
		whereToAddContent.appendChild(this.br);
	}

	AddValueInputElement(innerText, id, defaultValue, functionToAdd, container) {
		var whereToAddContent = container || this.el;

		this.text = document.createElement("p");
		this.br = document.createElement("br");

		this.text.innerText = innerText;
		this.text.id = id + "-text";
		whereToAddContent.appendChild(this.text);

		var inputElement = document.createElement("input");
		inputElement.id = id;
		inputElement.type = "number";
		if (defaultValue.default) {
			inputElement.value = defaultValue.default;
		}
		else {
			inputElement.value = 0;
		}
		
		if (defaultValue.max)
			inputElement.max = defaultValue.max;
		if (defaultValue.min)
			inputElement.min = defaultValue.min;
		if (defaultValue.step)
			inputElement.step = defaultValue.step;

		inputElement.onchange = functionToAdd;

		whereToAddContent.appendChild(inputElement);
		whereToAddContent.appendChild(this.br);
	}

	AddCheckboxElement(innerText, id, defaultValue, functionToAdd, container) {
		var whereToAddContent = container || this.el;

		var content = document.createElement("div");
		whereToAddContent.appendChild(content);

		var inputElement = document.createElement("input");
		inputElement.id = id;
		inputElement.type = "checkbox";
		inputElement.checked = defaultValue;

		inputElement.onchange = functionToAdd;

		content.appendChild(inputElement);

		var label = document.createElement("label");

		label.innerText = innerText;
		label.for = id;

		content.appendChild(label);

	}

	Collapsible(label, container, isGrid) {
		var button = document.createElement("button");
		button.innerText = label;
		if (container) {
			container.appendChild(button);
		}
		else {
			this.el.appendChild(button);
		}

		var content = document.createElement("div");
		content.classList.add("collapsible");
		content.style.display = "none"
		if (container) {
			container.appendChild(content);
		}
		else {
			this.el.appendChild(content);
		}

		button.addEventListener ("click", function() {
			this.classList.toggle("active");
			var content = this.nextElementSibling;
			if (content.style.display !== "none") {
				content.style.display = "none";
				this.classList.remove("red-button");
			} else {
				if (isGrid) {
					content.style.display = "grid";
					content.classList.add("grid");
				}
				else {
					content.style.display = "block";
				}
				this.classList.add("red-button");
			}
		});

		return content;
	}

	AddBibliothequeButton(objectName, label, container, functionToAdd, classToAdd) {
		var whereToAddContent = container || this.el;
		var button = document.createElement("button");

		var img = document.createElement("img");
		img.src = "./models/bibliotheque/images/" + objectName.replace("bibliotheque/", "") + ".png";
		button.appendChild(img);

		var textButton = document.createElement("p");
		textButton.innerText = label;
		button.appendChild(textButton);

		whereToAddContent.appendChild(button);

		button.onclick = functionToAdd;

		if (classToAdd) {
			for(var i = 0; i < classToAdd.length; i++) {
				button.classList.add(classToAdd[i]);
			}
		}
	}

	AddButton(label, container, functionToAdd, classToAdd) {
		var whereToAddContent = container || this.el;
		var button = document.createElement("button");
		button.innerText = label;

		whereToAddContent.appendChild(button);

		button.onclick = functionToAdd;

		if (classToAdd) {
			for(var i = 0; i < classToAdd.length; i++) {
				button.classList.add(classToAdd[i]);
			}
		}

	}

/*
	AddRemoveRoom(container) {
		var whereToAddContent = container || this.el;

		this.br = document.createElement("br");

		var button = document.createElement("button");
		button.innerText = "Retrecir";

		whereToAddContent.appendChild(button);

		button.addEventListener ("click", function() {
			this.envGenerator.RemoveRoom();
		}.bind(this), false);


		var button = document.createElement("button");
		button.innerText = "Agrandir";

		whereToAddContent.appendChild(button);

		button.addEventListener ("click", function() {
			this.envGenerator.AddRoom();
		}.bind(this), false);

		whereToAddContent.appendChild(this.br);
	}*/

	
}